import { render } from "./Promocodes.vue?vue&type=template&id=c8fad0e0&scoped=true"
import script from "./Promocodes.vue?vue&type=script&lang=js"
export * from "./Promocodes.vue?vue&type=script&lang=js"

import "./Promocodes.vue?vue&type=style&index=0&id=c8fad0e0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8fad0e0"]])

export default __exports__